import React from 'react';
import { Book, Sunset, Trees, Zap } from 'lucide-react';
import { ChannelsCard, FeaturesCards, Casestudies, Testimonials, IntegrationHero, FaqSection } from '../components/ui/sections';
import { HeroSection } from '../components/ui/hero';
import { Footer, Navbar1 } from '../components/ui/layout';
import { PricingSection } from '../components/ui/pricing';
import PageTransition from '../components/PageTransition';

const NewLanding = () => {


  return (
    <PageTransition>
      <div className="min-h-screen bg-background text-foreground">
        {/* Header - New Navbar */}
        <Navbar1
          logo={{
            url: "/",
            src: "/44logo.svg",
            alt: "44Agents Logo",
            title: "44Agents",
          }}
          menu={[
            {
              title: "Products",
              url: "#",
              items: [
                {
                  title: "Blog",
                  description: "The latest industry news, updates, and info",
                  icon: <Book className="size-5 shrink-0" />,
                  url: "/blog",
                },
                {
                  title: "Company",
                  description: "Our mission is to innovate and empower the world",
                  icon: <Trees className="size-5 shrink-0" />,
                  url: "/company",
                },
                {
                  title: "Careers",
                  description: "Browse job listing and discover our workspace",
                  icon: <Sunset className="size-5 shrink-0" />,
                  url: "/careers",
                },
                {
                  title: "Support",
                  description:
                    "Get in touch with our support team or visit our community forums",
                  icon: <Zap className="size-5 shrink-0" />,
                  url: "/support",
                },
              ],
            },
            {
              title: "Resources",
              url: "#",
              items: [
                {
                  title: "Help Center",
                  description: "Get all the answers you need right here",
                  icon: <Zap className="size-5 shrink-0" />,
                  url: "/help",
                },
                {
                  title: "Contact Us",
                  description: "We are here to help you with any questions you have",
                  icon: <Sunset className="size-5 shrink-0" />,
                  url: "/contact",
                },
                {
                  title: "Status",
                  description: "Check the current status of our services and APIs",
                  icon: <Trees className="size-5 shrink-0" />,
                  url: "/status",
                },
                {
                  title: "Terms of Service",
                  description: "Our terms and conditions for using our services",
                  icon: <Book className="size-5 shrink-0" />,
                  url: "/terms",
                },
              ],
            },
            {
              title: "Pricing",
              url: "#pricing",
            },
            {
              title: "Blog",
              url: "/blog",
            },
          ]}
          mobileExtraLinks={[
            { name: "Press", url: "/press" },
            { name: "Contact", url: "/contact" },
            { name: "Imprint", url: "/imprint" },
            { name: "Sitemap", url: "/sitemap" },
          ]}
          auth={{
            login: { text: "Log in", url: "/login" },
          }}
        />

        {/* Hero Section */}
        <HeroSection
          badge={{
            text: "Introducing our new components",
            action: {
              text: "Learn more",
              href: "/docs",
            },
          }}
          title="Build faster with beautiful components"
          description="Premium UI components built with React and Tailwind CSS. Save time and ship your next project faster with our ready-to-use components."
          actions={[
            {
              text: "Get Started",
              href: "/docs/getting-started",
              variant: "default",
              className: "rounded",
            },
          ]}
          image={{
            light: "https://www.launchuicomponents.com/app-light.png",
            dark: "https://www.launchuicomponents.com/app-dark.png",
            alt: "UI Components Preview",
          }}
        />

        {/* Case Studies Section */}
        <Casestudies />

        {/* Features Section */}
        <ChannelsCard />

        {/* FeaturesCards Section - Advanced tracking system */}
        <FeaturesCards />

        {/* Integration Hero Section */}
        <IntegrationHero />

        {/* Pricing Section */}
        <section id="pricing" className="py-20 px-6 bg-background hidden">
          <PricingSection
            plans={[
              {
                name: 'Basic',
                info: 'For most individuals',
                price: {
                  monthly: 350,
                  yearly: Math.round(350 * 12 * (1 - 0.12)),
                },
                features: [
                  { text: '1,000 minutes included' },
                ],
                btn: {
                  text: 'Start Your Free Trial',
                  href: '#',
                },
              },
              {
                name: 'Startup',
                info: 'For small businesses',
                price: {
                  monthly: 450,
                  yearly: Math.round(450 * 12 * (1 - 0.12)),
                },
                features: [
                  { text: '2,500 minutes included' },
                ],
                btn: {
                  text: 'Get started',
                  href: '#',
                },
              },
              {
                highlighted: true,
                name: 'Enterprise',
                info: 'For large organizations',
                price: {
                  monthly: 850,
                  yearly: Math.round(850 * 12 * (1 - 0.12)),
                },
                features: [
                  { text: '11,000 minutes included' },
                ],
                btn: {
                  text: 'Contact team',
                  href: '#',
                },
              },
            ]}
            heading="Plans that Scale with You"
            description="Whether you're just starting out or growing fast, our flexible pricing has you covered — with no hidden costs."
          />
        </section>

        {/* Testimonials Section */}
        <Testimonials />

        {/* FAQ Section */}
        <FaqSection
          title="Frequently Asked Questions"
          description="Everything you need to know about our platform"
          items={[
            {
              question: "What makes your platform unique?",
              answer: "Our platform stands out through its intuitive design, powerful automation capabilities, and seamless integration options. We've focused on creating a user experience that combines simplicity with advanced features.",
            },
            {
              question: "How does the pricing structure work?",
              answer: "Our pricing is based on the minutes your AI agents spend on calls — you only pay for what you use. Each plan includes a set number of minutes per month, with the option to top up as needed.",
            },
            {
              question: "What kind of support do you offer?",
              answer: "We provide comprehensive support through multiple channels. This includes 24/7 live chat, detailed documentation, video tutorials, and dedicated account managers for enterprise clients.",
            },
          ]}
          contactInfo={{
            title: "Still have questions?",
            description: "We're here to help you",
            buttonText: "Contact Support",
            onContact: () => window.location.href = "/contact",
          }}
        />

        {/* Footer */}
        <Footer />
      </div>
    </PageTransition>
  );
};

export default NewLanding;
